export default function search({ next, from, to, store, }) {
    // 라우터 변경 시 검색 창 닫기
    if (from.name !== to.name) {
        store.dispatch('app/closeSearch');
    }
    return next();
}
